export default "__VITE_ASSET__CMpOFZRr__"